export default "/images/regione.svg?a8e558a1cc90281267c191a36ef933ec";